import { render } from "./RentalTransferCreate.vue?vue&type=template&id=dd843874"
import script from "./RentalTransferCreate.vue?vue&type=script&lang=js"
export * from "./RentalTransferCreate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/driveapp2.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__